import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'momentjs'
})
export class MomentjsPipe implements PipeTransform {
  transform(date: any, format: any, ) {
    let lang = localStorage.getItem('language') || 'th';
    lang = lang.replace(/['"]+/g, '').toLowerCase().trim();

    if (lang.indexOf('en') === 0) {
       moment.locale('en');
       return date ? moment(date).format(format) : '';
    } else {
       moment.locale('th');
       // return date ? moment(date).add(543, 'year').format(format) : '';
       var resultYear  ='';
       if(format.includes('YYYY') || format.includes('yyyy')){
         resultYear = date ? moment(date).add(543, 'year').format('YYYY') : '';
         format = format.toString().replace('YYYY','##').replace('yyyy','##');
       }
       else {
         resultYear = date ? moment(date).add(543, 'year').format('YY') : '';
         format = format.toString().replace('YY','##').replace('yy','##');
       }
       var result = date ? moment(date).format(format) : '';
       result = result.replace('##',resultYear);
       return result;
    }
  }

}
